
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.63.11a.374.374 0 00-.528 0L5.87 4.342 1.639.11a.374.374 0 00-.53.529L5.343 4.87 1.11 9.102a.374.374 0 10.529.529L5.87 5.399l4.232 4.232a.375.375 0 10.528-.529L6.4 4.87 10.63.64a.373.373 0 000-.53V.11z","fill":"#fff"}})])
          )
        }
      }
    